import ToggleButton from "./ToggleButton";

const ToggleWithTitle = ({
  title,
  dispatchItemToredux,
  setToggleValue,
  defaultValue,
  reduxKey,
  isParent,
}) => {
  // // console.log(title);
  // console.log(defaultValue);
  return (
    <div
      className={`flex items-center justify-between w-full  ${
        isParent ? "border-none" : "border-b"
      }`}
    >
      <label className={`font-light text-sm`}>{title}</label>
      <ToggleButton
        defaultValue={defaultValue}
        dispatchItemToredux={dispatchItemToredux}
        setToggleValue={setToggleValue}
        reduxKey={reduxKey}
      />
    </div>
  );
};

export { ToggleWithTitle };
